'use strict';

angular.module('360StoreAngularApp')
	.directive('stDynamicTable', function (BUILD_DATE) { // BUILD_DATE can be injected here
		return {
			restrict: 'E', // Element type directive
			templateUrl: 'views/st-data-table.html?v=' + BUILD_DATE,
			scope: { // Isolate scope with bindings
				results: '<',       // One-way binding
				disableSums: '<?',  // Optional one-way binding
				captionPrefix: '@?' // Optional string attribute binding
			},
			controller: function ($scope) { // Controller receives $scope
				// In directives with isolate scope & controller, bindings are attached to $scope directly
				// So, instead of $ctrl.results, you'd use $scope.results

				$scope.columnKeys = [];
				$scope.internalSums = null;

				function calculateSums() {
					if ($scope.disableSums || !$scope.results || $scope.results.length === 0) {
						$scope.internalSums = null;
						return;
					}

					const firstRow = $scope.results[0];
					if (!firstRow) {
						$scope.internalSums = null;
						return;
					}

					// If columnKeys haven't been set by $onChanges or $onInit for current results, set them
					if (!$scope.columnKeys || $scope.columnKeys.length === 0 || ($scope.results[0] && Object.keys($scope.results[0]).join() !== $scope.columnKeys.join())) {
						$scope.columnKeys = Object.keys(firstRow);
					}

					let sums = {};
					let atLeastOneSumCalculated = false;

					$scope.columnKeys.forEach(colName => { // Use established $scope.columnKeys
						const lowerColName = colName.toLowerCase();
						const firstValue = firstRow[colName];

						let shouldSumThisColumn = false;
						if (angular.isNumber(firstValue)) {
							shouldSumThisColumn = lowerColName.includes('count') ||
								lowerColName.includes('revenue') ||
								lowerColName.includes('price') ||
								lowerColName.includes('amount') ||
								lowerColName.includes('total') ||
								lowerColName.includes('hours') ||
								lowerColName.includes('gain');
							if (lowerColName.includes('percent') || lowerColName.includes('%')) {
								shouldSumThisColumn = false;
							}
						}

						if (shouldSumThisColumn) {
							sums[colName] = $scope.results.reduce((currentSum, eachRow) => {
								const val = eachRow[colName];
								return currentSum + (angular.isNumber(val) ? val : 0);
							}, 0);
							atLeastOneSumCalculated = true;
						} else {
							sums[colName] = null;
						}
					});
					$scope.internalSums = atLeastOneSumCalculated ? sums : null;
				}

				// For directives, watching bindings is typically done with $scope.$watch or $onChanges if controllerAs syntax is used
				// With `bindings: {}` in a component, $onChanges is natural.
				// With `scope: {}` in a directive, you can $watch for changes to the bound attributes.

				$scope.$watch('results', function (newVal, oldVal) {
					if (newVal === oldVal && !$scope.columnKeys.length && newVal && newVal.length > 0) { // Initial load check
						// Or just rely on init logic below, but this catches actual changes better
					}
					if (newVal) {
						if (newVal.length > 0) {
							$scope.columnKeys = Object.keys(newVal[0]);
						} else {
							$scope.columnKeys = [];
						}
						calculateSums();
					} else {
						$scope.columnKeys = [];
						$scope.internalSums = null;
					}
				}, true); // true for deep watch on array/object

				$scope.$watch('disableSums', function (newVal, oldVal) {
					if (newVal !== oldVal) {
						calculateSums();
					}
				});

				// Initial setup
				if ($scope.results && $scope.results.length > 0 && (!$scope.columnKeys || $scope.columnKeys.length === 0)) {
					$scope.columnKeys = Object.keys($scope.results[0]);
				}
				calculateSums();


				$scope.getColumnKeys = function () {
					return $scope.columnKeys;
				};

				$scope.hasSumValues = function () {
					if (!$scope.internalSums) {
						return false;
					}
					return $scope.columnKeys.some(key => angular.isDefined($scope.internalSums[key]) && $scope.internalSums[key] !== null);
				};

				const numericKeyMemoCache = new Map();

				$scope.isNumericOrCurrencyKey = function (key) {
					if (numericKeyMemoCache.has(key)) {
						return numericKeyMemoCache.get(key);
					}

					let isNumeric = false; // Use a single variable to hold the result.

					if (typeof key === 'string') {
						const lowerKey = key.toLowerCase();

						// Check based on the value in the first row of data
						const valueInFirstRow = ($scope.results && $scope.results.length > 0 && $scope.results[0] !== null) ? $scope.results[0][key] : undefined;

						if (angular.isNumber(valueInFirstRow) && !(lowerKey.includes('date') || lowerKey.includes('when') || lowerKey.includes('percent') || lowerKey.includes('%'))) {
							isNumeric = true;
						} else {
							// Fallback to checking key names if the first row isn't a number
							isNumeric = lowerKey.includes('revenue') || lowerKey.includes('price') ||
								lowerKey.includes('amount') || lowerKey.includes('total') ||
								lowerKey.includes('count') || lowerKey.includes('hours') ||
								lowerKey.includes('gain') || lowerKey.endsWith('_id') ||
								lowerKey.endsWith('qty');
						}
					}
					numericKeyMemoCache.set(key, isNumeric);

					return isNumeric;
				};

				$scope.sortModel = $scope.sortModel ?? {key: '', descending: false};
			}
		};
	});
